/**
 * Method used to search for tags saved in the DAMS database.
 * @param museumIds   Array[int]  List of the museum IDs to search in.
 * @param tagTitle  string  The name of the tag to search for.
 * @param tagTypes   string  The type of tag, "foldertag", "ems-sync-tag" is the only one supported for now.
 * @returns {Promise<*|*[]>}
 */
import {clientLog} from "../clientLog";
import {damsSearch} from "../app/damsFetch";
import decamelizeKeysDeep from "decamelize-keys-deep";

export const tagsSearchHandler = async (museumIds, tagTitle = '*', tagTypes = ['foldertag']) => {

    if (!Array.isArray(museumIds)) {
        throw new Error('museumIds must be an array');
    }

    if (!Array.isArray(tagTypes)) {
        throw new Error('tagTypes must be an array');
    }

    const searchParams = new URLSearchParams(
        decamelizeKeysDeep({
            q: `_title_:${tagTitle}`,
            fl: "title,id",
            sort: "title asc",
            expand: true,
            documentType: `(${tagTypes.length > 0 ? tagTypes.join(" OR ") : tagTypes[0]})`,
            museums: museumIds.join(","),
        })
    );

    try {
        const res = await damsSearch(searchParams);
        if (res.count > 0) {
            return res.models;
        } else {
            return [];
        }
    } catch (e) {
        clientLog('error', 'failed to load saved tags', 'tagsearchhandler');
        return [];
    }
};